import { useStore, useUnit } from 'effector-react';
import $$api from 'models/api';
import { $queryParams, clearParams } from 'models/location';
import { $global } from 'models/store-global';
import { useEffect } from 'react';

import ModalsService from 'services/ModalsService';

import useResources from 'hooks/useResources';

const useAdvisorLinker = () => {
    const { t } = useResources();
    const params = useStore($queryParams);
    const code = params['link-advisor'] || localStorage.getItem('link-advisor');

    const isAuthorized = useUnit($global.map((state) => state.auth?.userRole || 'guest')) !== 'guest';

    const handlers = {
        openInviteModality: async () => {
            if (code) {
                const advisor = await $$api.advisor.getAdvisorByCodeFx(code);
                ModalsService.showModality(
                    t('advisor.acceptAdvisorInviteModal.title'),
                    t('advisor.acceptAdvisorInviteModal.body', { ...advisor }),
                    {
                        closeButton: t('advisor.acceptAdvisorInviteModal.closeButton'),
                        confirmButton: t('advisor.acceptAdvisorInviteModal.confirmButton'),
                        onConfirm: async () => {
                            await $$api.advisor.linkAdvisorFx(code);
                            localStorage.removeItem('link-advisor');
                            await $$api.participants.getCommunityFx(undefined);
                        },
                        onCancel: () => {
                            localStorage.removeItem('link-advisor');
                        },
                    },
                );
            }
        },
    };

    useEffect(() => {
        if (code) {
            if (isAuthorized) {
                handlers.openInviteModality();
            } else {
                localStorage.setItem('link-advisor', code);
                clearParams();
            }
        }
    }, [code, isAuthorized]);
};

export default useAdvisorLinker;
